module.exports = "<div class=\"alps-loading-bar\">\r\n  <div class=\"alps-loading-bar-progress\" [style.width]=\"progress + '%'\" [style.backgroundColor]=\"color\" [style.color]=\"color\"\r\n       [style.height]=\"height\" [style.opacity]=\"show ? '1' : '0'\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/component/alps-loading-bar/alps-loading-bar.component.html
// module id = 509
// module chunks = 16